import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCarType } from './carThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCarKey } from '../../sell/sellKeys';
const SLICE_NAME = 'type';

export const typeSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCarType(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarType });
        builder.addCase(clearCarKey, () => commonInitialState);
    },
});

export const { clearCarType } = typeSlice.actions;

export const type = typeSlice.reducer;
